import { helper } from '@ember/component/helper';
import type { GraphLine, GraphGeometry } from '../index.d.ts';
import { generateEnvelopeFill } from '../utils/graphUtils.ts';

export interface EnvelopeFillSignature {
  Args: {
    Positional: [];
    Named: { line: GraphLine; geometry: GraphGeometry };
  };
  Return: string;
}

const envelopeFill = helper<EnvelopeFillSignature>((params, { line, geometry }) => {
  return generateEnvelopeFill(line, geometry);
});

export default envelopeFill;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'envelope-fill': typeof envelopeFill;
  }
}
